export default __webpack_public_path__ + "static/media/aerolab-logo.0a8fb170.svg";